import { getBorrowerDocumentationByLoanIdAndBorrowerId } from '@nemuru-eng/js-api-client';
import { useEffect } from 'react';

import { useCache } from '@/hooks/requests/useCache';

interface UseKYCDocumentIdImagesProps {
  loanId: string;
  borrowerId: string;
  onLoaded?: () => void;
  onError?: (revalidate: () => void) => void;
}

export const useKYCDocumentIdImages = ({ loanId, borrowerId, onLoaded, onError }: UseKYCDocumentIdImagesProps) => {
  const {
    data: borrowerDocumentation,
    loading,
    revalidate,
  } = useCache(
    getBorrowerDocumentationByLoanIdAndBorrowerId,
    {
      loanId,
      borrowerId,
    },
    { fallbackData: [] },
  );

  useEffect(() => {
    if (loading) return;

    if (loading === false && !borrowerIdImages?.passport && !borrowerIdImages?.documentIdFront) {
      onError?.(revalidate);
      return;
    }

    onLoaded?.();
  }, [loading]);

  const getBorrowerIdImages = () => {
    if (borrowerDocumentation && borrowerDocumentation.length > 0) {
      const passport = borrowerDocumentation.find((document) => document.type === 'passport');
      const documentIdFront = borrowerDocumentation.find((document) => document.type === 'document_id_front');
      const documentIdBack = borrowerDocumentation.find((document) => document.type === 'document_id_back');

      return {
        passport,
        documentIdFront,
        documentIdBack,
      };
    }
  };

  const borrowerIdImages = getBorrowerIdImages();

  return {
    borrowerIdImages,
    loading,
  };
};
